<template>
  <div class="arrangeListDiv">
    <div style="padding: 20px; background: #fff">
      <div class="arrangeTitle">
        <el-form label-width="80px" :inline="true" :model="filter" size="small">
       

          <el-form-item label="状态">
            <el-select filterable v-model="filter.status"  clearable placeholder="请选择状态" size="small" >
              <el-option label="未开始" value="0" ></el-option>
              <el-option label="进行中" value="1" ></el-option>
              <el-option label="已结束" value="2" ></el-option>
            </el-select>
          </el-form-item>
             <el-form-item label="安排名称">
            <el-input v-model="filter.arrange_name" placeholder="请输入安排名称" />
          </el-form-item>
          <el-form-item>
           <el-button type="primary" size="small" @click="getJudgeList" >查询</el-button >
          <el-button  size="small" @click="reset" >重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table :data="tableData" style="width: 100%" class="custom-table">
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span class="status" :style="getStatusStyle(scope.row.status)">{{
                getStatusText(scope.row.status)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="arrange_name" label="安排名称" align="center">
          </el-table-column>
          <el-table-column prop="candidate_ids_str" label="成果数" align="center">
          </el-table-column>
          <el-table-column prop="group_id_str" label="评委小组" align="center">
          </el-table-column>
          <el-table-column prop="schedule_location" label="地点" align="center">
          </el-table-column>
          <el-table-column
            prop="schedule_datetime"
            label="评审日期"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="duties_name" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="handleRow(scope.row, 'look')"
                >查看</el-button
              >
              <!-- <el-button
                type="primary"
                size="small"
                @click="handleRow(scope.row, 'upload')"
                >上传</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <div class="paginBox">
          <div class="countNumber">共{{ total }}条</div>
          <div class="rightPagin">
            <el-pagination
              @size-change="sizePagination"
              :current-page="filter.currPage"
              @current-change="currentPagination"
              :page-size="filter.pageSize"
              background
              layout="prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="goBack">
        <div class="goBackBtn">
          <el-button type="primary" size="small" @click="handleRow('goBack')"
            >返回</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="上传文件"
      :visible.sync="uploadDialogVisible"
      width="500px"
      :before-close="closeUploadDialog"
    >
      <div style="padding: 15px 0; font-size: 20px; text-align: center">
        请确认上传的签名图片的准确性
      </div>
      <el-upload
        class="upload"
        style="width: 100%"
        drag
        :action="`${baseURL}/common/uploadFile`"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        :on-preview="handlePreview"
        :limit="1"
        :file-list="uploadFileList"
        accept=".jpg,.jpeg,.png"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
        <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload">确认上传</el-button>
        <el-button @click="closeUploadDialog">取消</el-button>
      </span>
    </el-dialog>
  </div>
  <!-- 上传文件对话框 -->
</template>
<script>
import { getBaseUrl } from "@/config";
export default {
  name: "ArrangeList",

  data() {
    return {
      total: 0,
      filter: {
        arrange_name:'',
        status:'',
        currPage: 1,
        pageSize: 8,
      },
      baseURL: getBaseUrl(),
      uploadDialogVisible: false,
      uploadFileList: [],
      currentUploadRow: null,
      tableData: [],
    };
  },
  mounted() {
    this.getJudgeList();
  },
  methods: {
    reset(){
      this.filter.arrange_name=''
      this.filter.status=''
      this.getJudgeList()
    },
    sizePagination(e) {
      this.filter.currPage = e;
      this.getJudgeList();
    },
    currentPagination(e) {
      this.filter.currPage = e;
      this.getJudgeList();
    },
    getJudgeList() {
      this.$API.getJudge(this.filter).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.pageInfo.allRows;
        console.log("res=========", res);
      });
    },
    getStatusText(status) {
      const statusMap = {
        0: "未开始",
        1: "进行中",
        2: "已结束",
      };
      return statusMap[status] || status;
    },
    getStatusStyle(status) {
      const styleMap = {
        0: {
          background: "#FEE2E2",
          color: "#DC2626",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "14px",
          display: "inline-block",
        },
        1: {
          background: "#FEF3C7",
          color: "#D97706",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "14px",
          display: "inline-block",
        },
        2: {
          background: "#F2F3F5",
          color: "#6B7280",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "14px",
          display: "inline-block",
        },
      };
      return styleMap[status] || {};
    },
    handleRow(row, type) {
      switch (type) {
        case "look":
          this.$router.push({
            path: "/bgManage/judge/reviewList",
            query: { xid: row.xid },
          });
          //   this.$router.push("/bgManage/judge/reviewList");
          break;
        case "upload":
          this.currentUploadRow = row;
          this.uploadDialogVisible = true;
          // this.$message.warning('待开放')
          break;
        case "goBack":
          this.$router.push("/bgManage/judge/arrangeList");
          break;
      }
    },
    handleRemove(e) {
      console.log("e=========", e);
      this.uploadFileList = this.uploadFileList.filter(
        (item) => item.url !== e.url
      );
    },
    handlePreview(e) {
      window.open(e.url, "_blank");
    },
    handleSuccess(e) {
      this.uploadFileList.push({
        name: e.url_name,
        url: e.url,
      });
      console.log("e=========", e);
    },
    submitUpload() {
      if (this.uploadFileList.length === 0) {
        this.$message.warning("请选择要上传的文件");
        return;
      }
      this.$API
        .saveSignature({
          arrange_xid: this.currentUploadRow.xid,
          signature_url: this.uploadFileList[0].url,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.uploadDialogVisible = false;
          this.filter.currPage = 1;
          this.getJudgeList();
          console.log("res=========", res);
        });
    },
    closeUploadDialog() {
      this.uploadDialogVisible = false;
      this.uploadFileList = [];
    },
  },
};
</script>
<style scoped lang="scss">

::v-deep .el-form-item__label{
  font-weight: 500 !important;
}
::v-deep .el-upload {
  width: 100%;
}
::v-deep .el-upload-dragger {
  width: 100%;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
.goBackBtn {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 100%;
  padding-right: 60px;
}
.goBack {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 60px;
  background: #000000;
  border-radius: 0px 0px 0px 0px;
}
::v-deep .el-table__header-wrapper th {
  background: #f2f5fb !important;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #111827;
}
.arrangeTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #595959;
}
.arrangeListDiv {
  width: 100%;
  height: 700px;
  border-radius: 6px;
  background: #fff;
}
.status{
    width: 72px;
  height: 28px;
  line-height: 28px;
}
.countNumber {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #515a6e;
}
.paginBox {
  display: flex;
  justify-content: end;
  padding: 0 20px 20px 0;
  align-items: center;
  margin-top: 20px;
  width: 100%;
}

::v-deep .el-pagination.is-background .btn-prev {
  background: none;
}

::v-deep .el-pagination .btn-next .el-icon {
  font-size: 18px;
}

::v-deep .el-pagination .btn-prev .el-icon {
  font-size: 18px;
}

::v-deep .btn-next {
  width: 36px;
  height: 36px;
  background-color: #ffffff !important;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #e5e5e5;
}

::v-deep .btn-prev {
  width: 36px;
  height: 36px;
  background-color: #ffffff !important;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #e5e5e5;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #ffffff;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #2f86ff;
  font-weight: 400;
  font-size: 14px;
  color: #2f86ff;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

::v-deep .el-pagination.is-background .el-pager li {
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #b4b4b4;
  background: none;
  width: 36px;
  height: 36px;
  font-weight: 400;
  font-size: 14px;
  color: #313131;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 35px;
}
</style>
